module.exports = __webpack_public_path__ + "img/img_mao.de567815.png";